/* eslint-disable no-mixed-operators */
import * as React from 'react';
import { connect } from 'react-redux';
import { Dropdown, IDropdownOption } from '@fluentui/react/lib/Dropdown';
import '../../../core/scss/_customize.scss';
import Template from '../../../core/libraries/Template';
import Constants from '../../../core/libraries/Constants';
import RbButton, { ButtonSize } from '../../../bosch-react/components/button/RbButton';
import { RootState } from '../../../store/store';
import { updateField, updateStep } from '../actions';
import { getSuperiorDepsDispatch, loadLLDivisionAdmin, getDirectManagerDispatch } from '../thunks';
import { showDialog, confirmDialog } from '../../Dialog/actions';
import { IResponibleDepartment } from '../types';
import { IUserProfile } from '../../Auth/types';
import Helper from '../../../core/libraries/Helper';
import CustomizedPeoplePicker from '../../../core/components/PeoplePicker/CustomizedPeoplePicker';
import { PrincipalType } from '../../../core/components/PeoplePicker/types';
import { removeAliasDomain } from '../../../utils/converter';
import { IGetOrgInfoReq, Organization, QueryTypeEnums } from '../../../services/type';
import { IPersonaProps, TextField } from '@fluentui/react';

interface ReleaseProps {
    userProfile: IUserProfile | undefined,
    commonReport: any,
    mode: string,
    rouList: Organization[],
    changedAuthor: boolean | undefined,
    showDialog: typeof showDialog,
    confirmDialog: typeof confirmDialog,
    updateField: typeof updateField,
    updateStep: typeof updateStep,
    getSuperiorDepsDispatch: any,
    loadLLDivisionAdmin: any,
    validation: any,
    getDirectManagerDispatch: any,
    SPFManagerList: Organization[],
}

class Release extends React.Component<ReleaseProps, any> {
    replacedROURef: React.RefObject<any> = React.createRef();
    llDivisionAdminRef: React.RefObject<any> = React.createRef();
    feberDepartmentRef: React.RefObject<any> = React.createRef();
    additionalApproversRef: React.RefObject<any> = React.createRef();
    notificationUsersRef: React.RefObject<any> = React.createRef();
    feberGroupRef: React.RefObject<any> = React.createRef();
    constructor(props: ReleaseProps) {
        super(props);
        this.renderResponsibleDepartmentForBSH = this.renderResponsibleDepartmentForBSH.bind(this);
        this.renderResponsibleDepartment = this.renderResponsibleDepartment.bind(this);
        this.renderChangeDepartment = this.renderChangeDepartment.bind(this);
        this.renderAdditionalApprove = this.renderAdditionalApprove.bind(this);
        this.renderNotification = this.renderNotification.bind(this);
        this.renderDivisionalLLAdmin = this.renderDivisionalLLAdmin.bind(this);
        this.renderDivisionalLLAdminNote = this.renderDivisionalLLAdminNote.bind(this);
        this.alertNoResponsibleDepartment = this.alertNoResponsibleDepartment.bind(this);

        this.renderSPFManager = this.renderSPFManager.bind(this);
        this.renderChangeSPFManager = this.renderChangeSPFManager.bind(this);
        this.alertNoSPFManager = this.alertNoSPFManager.bind(this);
        this.alertNotInCRDivision = this.alertNotInCRDivision.bind(this);
        this.alertSameApprover = this.alertSameApprover.bind(this);
    }

    componentDidMount() {
        const { commonReport, changedAuthor } = this.props
        // const isCRRnD = commonReport.Division === "CR" && commonReport.UploadType === Constants.UPLOAD_TYPE.RnD
        if (!!changedAuthor) {
            this.props.showDialog(Constants.DIALOG_MESSAGE.LOAD_ROU);
            if (!commonReport.Authors || commonReport.Authors.length === 0) {
                let author = [removeAliasDomain(Helper.setEmptyIfNull(commonReport.CreatedBy))]
                let getRouReq: IGetOrgInfoReq = {
                    identitiesOrOrgNames: author,
                    queryType: QueryTypeEnums.Identities
                }
                this.props.getSuperiorDepsDispatch(getRouReq, this.props.userProfile, (lists: Organization[]) => {
                    if (lists.length > 0) {
                        if (commonReport.UploadType !== Constants.UPLOAD_TYPE.LL) {
                            this.props.showDialog(false);
                        }
                        else {
                            this.props.loadLLDivisionAdmin(commonReport.Division, () => {
                                this.props.showDialog(false);
                            });
                        }
                    }
                    else {
                        this.alertNoResponsibleDepartment();;
                    }
                });
            }
            else {
                //previus version
                let getRouReq: IGetOrgInfoReq = {
                    identitiesOrOrgNames: this.props.commonReport.Authors,
                    queryType: QueryTypeEnums.Identities
                }
                this.props.getSuperiorDepsDispatch(getRouReq, this.props.userProfile, (lists: Organization[]) => {
                    if (lists.length > 0) {
                        if (this.props.commonReport.UploadType !== Constants.UPLOAD_TYPE.LL) {
                            this.props.showDialog(false);
                        }
                        else {
                            this.props.loadLLDivisionAdmin(this.props.commonReport.Division, () => {
                                this.props.showDialog(false);
                            });
                        }
                    }
                    else {
                        this.alertNoResponsibleDepartment();;
                    }
                });
            }
        }
    }

    render() {
        if (this.props.changedAuthor === true) {
            this.props.commonReport.ROU = null;
            this.props.commonReport.SPFManager = null;
        }
        return (
            <React.Fragment>
                {/* {((this.props.rouList.filter(r => r.division === "BSH" && this.props.commonReport.UploadType === Constants.UPLOAD_TYPE.LL)).length > 0) ?
                    <React.Fragment>
                        {this.renderResponsibleDepartmentForBSH()}
                        {Template.renderNote("Since this is a BSH report, please provide the approver directly rather than input organization name.")}
                    </React.Fragment>
                    : <React.Fragment>
                        {this.renderResponsibleDepartment()}
                        {this.renderChangeDepartment()}
                    </React.Fragment>} */}
                {this.renderResponsibleDepartment()}
                {this.renderChangeDepartment()}
                {this.renderSPFManager()}
                {this.renderChangeSPFManager()}
                {this.renderAdditionalApprove()}
                {this.renderNotification()}
                {this.renderDivisionalLLAdmin()}
                {this.renderDivisionalLLAdminNote()}
            </React.Fragment>
        );
    }
    handleOnChangeResponsibleDepartmentForBSH = (persona: IPersonaProps[]) => {
        let items = this.replacedROURef.current.getSelectedItems();
        let results: any[] = [];
        items.forEach((item: any) => {
            !!item.loginName && results.push(removeAliasDomain(item.loginName));
        });

        this.props.updateField("ROU", ((!!results) ? results[0] : null));
        if (!!results) {
            Helper.runNewTask(() => {
                this.props.showDialog(Constants.DIALOG_MESSAGE.LOAD_LL_DIVISIONAL_ADMIN);
                this.props.loadLLDivisionAdmin(this.props.commonReport.Division, () => {
                    this.props.showDialog(false);
                });
            });
        }
        this.props.updateField("PreSelectedROU", persona);

    }

    renderResponsibleDepartmentForBSH() {
        if (this.props.changedAuthor === true) {
            return Template.renderUploadRowTemplate("Responsible department",
                <CustomizedPeoplePicker
                    principalType={PrincipalType.People}
                    itemLimit={1}
                    defaultValue={[]}
                    componentRef={this.replacedROURef}
                    onChange={this.handleOnChangeResponsibleDepartmentForBSH}
                />, Constants.UPLOAD_INFO_MESSAGE.RESPONSIBLE_DEPARTMENT, "", true, this.props.validation.ROU);
        }
        else {
            return Template.renderUploadRowTemplate("Responsible department",
                <CustomizedPeoplePicker
                    principalType={PrincipalType.People}
                    itemLimit={1}
                    defaultValue={!!this.props.commonReport.PreSelectedROU ? this.props.commonReport.PreSelectedROU : []}
                    componentRef={this.replacedROURef}
                    onChange={this.handleOnChangeResponsibleDepartmentForBSH}
                />, Constants.UPLOAD_INFO_MESSAGE.RESPONSIBLE_DEPARTMENT, "", true, this.props.validation.ROU);
        }
    }

    renderResponsibleDepartment() {
        let infoMessage = "";
        if (this.props.commonReport.Division === "CR" && this.props.commonReport.UploadType === Constants.UPLOAD_TYPE.RnD) {
            infoMessage = "Since this is a CR report, The department head will be the last additional approver."
        }
        else {
            infoMessage = Constants.UPLOAD_INFO_MESSAGE.RESPONSIBLE_DEPARTMENT
        }

        const options = this.props.rouList.map(rou => {
            return {
                key: rou.managerID,
                text: ((this.props.mode === "admin") ? rou?.orgName : rou?.managerFullName),
                data: rou
            } as IDropdownOption;
        });
        if (!!this.props.commonReport.ROU) {
            if (!!this.props.commonReport.ROU.Division) {
                this.props.commonReport.ROU = this.props.commonReport.ROU.ROU;
            }
        }
        return Template.renderUploadRowTemplate("Responsible department",
            <Dropdown
                selectedKey={!!this.props.commonReport.ROU && this.props.commonReport.ROU.managerID}
                options={options}
                onChange={(event, option) => {
                    this.props.updateField("ROU", option?.data);
                    this.props.updateField("Department", option?.data.orgName);
                    this.props.updateField("Division", option?.data.division);

                    if (this.props.commonReport.UploadType === Constants.UPLOAD_TYPE.LL) {
                        Helper.runNewTask(() => {
                            this.props.showDialog(Constants.DIALOG_MESSAGE.LOAD_LL_DIVISIONAL_ADMIN);
                            this.props.loadLLDivisionAdmin(option?.data.division, () => {
                                this.props.showDialog(false);
                            });
                        });
                    }
                    this.forceUpdate();
                }}
            />, infoMessage, "", true, this.props.validation.ROU);

    }

    renderChangeDepartment() {
        return (
            <div className="ms-Grid upload-change-row">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm2">  </div>
                    <div className="ms-Grid-col ms-sm5">
                        <CustomizedPeoplePicker principalType={PrincipalType.Group} componentRef={this.feberDepartmentRef} />
                    </div>
                    <div className="ms-Grid-col ms-sm5">
                        <RbButton label="Change department" size={ButtonSize.Tiny}
                            onClick={() => {
                                let items: any[] = this.feberDepartmentRef.current.getSelectedItems();
                                if (!!items) {
                                    this.props.showDialog(Constants.DIALOG_MESSAGE.LOAD_ROU);
                                    let getROUReq: IGetOrgInfoReq = {
                                        identitiesOrOrgNames: items.map(i => {
                                            return i.displayName
                                        }),
                                        queryType: QueryTypeEnums.OrgNames
                                    }
                                    this.props.getSuperiorDepsDispatch(getROUReq, this.props.userProfile, (lists: IResponibleDepartment[]) => {
                                        if (lists.length > 0) {
                                            if (this.props.commonReport.UploadType !== Constants.UPLOAD_TYPE.LL) {
                                                this.props.showDialog(false);
                                                //Group Manager
                                                this.props.updateField("SPFManager", null);
                                            }
                                            else {
                                                this.props.loadLLDivisionAdmin(this.props.commonReport.Division, () => {
                                                    this.props.showDialog(false);
                                                });
                                            }
                                        }
                                        else {
                                            this.props.commonReport.ROU = null;
                                            this.alertNoResponsibleDepartment();
                                        }
                                    });
                                }
                            }
                            } />
                    </div>
                </div>
            </div>
        );
    }

    renderSPFManager() {
        let spfManagerList = this.props.SPFManagerList;
        if (this.props.commonReport.Division === "CR" && this.props.commonReport.UploadType === Constants.UPLOAD_TYPE.RnD) {
            const filterSPFManager = !!spfManagerList && spfManagerList.length > 0 && spfManagerList.filter(r => r.division === "CR") || []
            const options = filterSPFManager.map(group => {
                return {
                    key: group?.managerID,
                    text: ((this.props.mode === "admin") ? group?.orgName : group?.managerFullName),
                    data: group
                } as IDropdownOption;
            });
            return Template.renderUploadRowTemplate("Strategic Portfolio Owner",
                <Dropdown
                    selectedKey={(!!this.props.commonReport.SPFManager) ? this.props.commonReport.SPFManager.managerID : null}
                    options={options}
                    onChange={(event, option) => {
                        this.props.updateField("SPFManager", option?.data);
                        this.forceUpdate();
                    }}
                />, Constants.UPLOAD_INFO_MESSAGE.GROUP_MANAGER, "", true, this.props.validation.SPFManager);
        }
        else {
            return null;
        }
    }

    handleOnChangeSPFManager = () => {
        this.props.updateField("SPFManager", null);
        let items: any[] = this.feberGroupRef.current.getSelectedItems();
        if (!!items) {
            this.props.showDialog(Constants.DIALOG_MESSAGE.LOAD_GM);
            let request: IGetOrgInfoReq = {
                identitiesOrOrgNames: items.map(i => {
                    return i.displayName
                }),
                queryType: QueryTypeEnums.OrgNames
            }

            this.props.getDirectManagerDispatch(request, this.props.userProfile, (lists: Organization[]) => {
                if (lists.length > 0) {
                    this.props.showDialog(false);
                    let someNotCRDiv = lists.some(list => list.division.toLowerCase() !== "cr")
                    if (someNotCRDiv) {
                        this.alertNotInCRDivision();
                        this.props.updateField("SPFManager", null);
                    }
                }
                else {
                    this.alertNoSPFManager();
                }

            },
                true);
        }
    }

    renderChangeSPFManager() {
        if (this.props.commonReport.Division === "CR" && this.props.commonReport.UploadType === Constants.UPLOAD_TYPE.RnD) {
            return (
                <div className="ms-Grid upload-change-row">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm2">  </div>
                        <div className="ms-Grid-col ms-sm5">
                            <CustomizedPeoplePicker principalType={PrincipalType.Group} componentRef={this.feberGroupRef} />
                        </div>
                        <div className="ms-Grid-col ms-sm5">
                            <RbButton label="Change SPF Owner" size={ButtonSize.Tiny}
                                onClick={() => this.handleOnChangeSPFManager()} />
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return null;
        }
    }

    handleOnChangeAdditionalApprovers = (persona: IPersonaProps[]) => {
        let items = this.additionalApproversRef.current.getSelectedItems();
        let results: any[] = [];
        items.forEach((item: any) => {
            !!item.loginName && results.push(removeAliasDomain(item.loginName));
        });
        this.props.updateField("AdditionalApprovers", results);
        this.props.updateField("PreSelectedAdditionalApprovers", persona);
    }

    renderAdditionalApprove() {
        return Template.renderUploadRowTemplate("Additional approvers",
            <CustomizedPeoplePicker
                principalType={PrincipalType.People}
                defaultValue={!!this.props.commonReport.PreSelectedAdditionalApprovers ? this.props.commonReport.PreSelectedAdditionalApprovers : []}
                componentRef={this.additionalApproversRef}
                onChange={this.handleOnChangeAdditionalApprovers}
            />,
            Constants.UPLOAD_INFO_MESSAGE.ADDITIONAL_APRROVERS, "(Optional)", true, this.props.validation.AdditionalApprovers);

    }

    handleOnChangeNotificationUsers = (persona: IPersonaProps[]) => {
        let items = this.notificationUsersRef.current.getSelectedItems();
        let results: any[] = [];
        items.forEach((item: any) => {
            !!item.loginName && results.push(removeAliasDomain(item.loginName));
        });
        this.props.updateField("NotificationUsers", results);
        this.props.updateField("PreSelectedNotificationUsers", persona);
    }

    renderNotification() {
        if (this.props.commonReport.UploadType !== "LL") {
            return Template.renderUploadRowTemplate("Notification",
                <CustomizedPeoplePicker
                    principalType={PrincipalType.People}
                    defaultValue={!!this.props.commonReport.PreSelectedNotificationUsers ? this.props.commonReport.PreSelectedNotificationUsers : []}
                    componentRef={this.notificationUsersRef}
                    onChange={this.handleOnChangeNotificationUsers}
                />,
                Constants.UPLOAD_INFO_MESSAGE.NOTIFICATION, "(Optional)", true, this.props.validation.NotificationUsers);
        }

    }

    renderDivisionalLLAdmin() {
        const { LLDivisionAdmin } = this.props.commonReport
        console.log(LLDivisionAdmin?.displayName);
        let rbTextField = !!LLDivisionAdmin && !!LLDivisionAdmin.displayName && LLDivisionAdmin.displayName && <TextField disabled={true}
            value={LLDivisionAdmin.displayName}
        /> || <></>

        if (this.props.commonReport.UploadType === "LL") {
            return Template.renderUploadRowTemplate("Divisional lessons learned coordinator",
                rbTextField, "", "", false);
        }
    }
    renderDivisionalLLAdminNote() {
        if (this.props.commonReport.UploadType === "LL") {
            return Template.renderCoordinatorNote('Cannot be changed manually, selection based on responsible department.');
        }
    }
    alertNoResponsibleDepartment() {
        this.props.showDialog(false);
        this.props.confirmDialog(Constants.CONFIRMATION_MESSAGE.NO_ROU.TITLE,
            Constants.CONFIRMATION_MESSAGE.NO_ROU.CONTENT
            , true, () => { });
    }

    alertNoSPFManager() {
        this.props.showDialog(false);
        this.props.confirmDialog(Constants.CONFIRMATION_MESSAGE.NO_GM.TITLE,
            Constants.CONFIRMATION_MESSAGE.NO_GM.CONTENT
            , true, () => { });
    }

    alertNotInCRDivision() {
        this.props.showDialog(false);
        this.props.confirmDialog(Constants.CONFIRMATION_MESSAGE.NOT_CR_GROUP.TITLE,
            Constants.CONFIRMATION_MESSAGE.NOT_CR_GROUP.CONTENT
            , true, () => { });
    }

    alertSameApprover() {
        this.props.showDialog(false);
        this.props.confirmDialog(Constants.CONFIRMATION_MESSAGE.SAME_APPROVER.TITLE,
            Constants.CONFIRMATION_MESSAGE.SAME_APPROVER.CONTENT
            , true, () => { });
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
    commonReport: state.upload.commonReport,
    mode: state.upload.mode,
    validation: state.upload.validation,
    rouList: state.upload.rouLists,
    changedAuthor: state.upload.changedAuthor,
    SPFManagerList: state.upload.SPFManagerList
});
export default connect(mapStateToProps, {
    showDialog,
    confirmDialog,
    updateField,
    updateStep,
    getSuperiorDepsDispatch,
    loadLLDivisionAdmin,
    getDirectManagerDispatch,
})(Release);
